import { createBlock } from './create'
import { deleteBlock } from './delete'
import { readCollection, readSingle } from './read'
import { updateBlock } from './update'

export const blocks = {
  create: createBlock,
  delete: deleteBlock,
  update: updateBlock,
  readCollection,
  readSingle,
}
